import { Platform } from '@angular/cdk/platform';
import { Injectable } from '@angular/core';
import { MemoryStorage } from './memory-storage';
import { KEYS } from '../../utils/constants/storage.constants';

@Injectable({
  providedIn: 'root',
})
export class LocalStorageService implements Storage {
  private readonly localStorage: Storage;

  constructor(private platform: Platform) {
    if (this.platform.isBrowser && window?.localStorage) {
      this.localStorage = window.localStorage;
    } else {
      this.localStorage = new MemoryStorage();
    }
  }

  get length(): number {
    return this.localStorage.length;
  }

  clear(): void {
    this.localStorage.clear();
  }

  getItem(key: string): string | null {
    return this.localStorage.getItem(key);
  }

  key(index: number): string | null {
    return this.localStorage.key(index);
  }

  removeItem(key: string): void {
    this.localStorage.removeItem(key);
  }

  contains(key: string): boolean {
    return this.localStorage.getItem(key) !== null;
  }

  setItem(key: string, value: string): void {
    this.localStorage.setItem(key, value);
  }
}
